import { GapChaseFilterBase, filterType, dataType } from '../../GapChaseFilterBase';
import Axios from 'axios';

export default class SpecialistChaseTypeFilter extends GapChaseFilterBase {
    constructor() {
        super();
        this.id = 53;
        this.name = "Specialist Chase Type";
        this.filterName = "SpecialistChaseType";
        //this.isHidden = false;
        this.filterType = filterType.checkbox;
        this.values = [
            {
                "label": "",
                "value": "SpecialistChaseType"
            }
        ];

        this.dataType = dataType.boolean;
        this.filterCategory = "Provider Level";
        this.filterGroupId = 4;
        this.placeholder = "Specialist Chase Type";

    }

}
